// Dit is een voorbeeld van een user settings interface. Deze kan uitgebreid worden met meer modules en instellingen naarmate de applicatie groeit.
export const USER_SETTINGS_MODULE_KEYS = {
    PERSONNEL_PLANNING: 'personnelPlanning',
    STAFFING: 'staffing',
} as const;

export type UserSettingsModuleKey = (typeof USER_SETTINGS_MODULE_KEYS)[keyof typeof USER_SETTINGS_MODULE_KEYS];

export interface PersonnelPlanningSettings {
    defaultView?: 'day' | 'week' | 'month';
    showInactiveEmployees?: boolean;
    uniqueRoleKeys?: string[];
}

export enum StaffingDisplayMode {
    All = 'all',
    Leave = 'leave',
    Planning = 'planning',
}

export interface StaffingSettings {
    displayMode?: StaffingDisplayMode;
}

export interface UserSettingsModuleMap {
    [USER_SETTINGS_MODULE_KEYS.PERSONNEL_PLANNING]: PersonnelPlanningSettings;
    [USER_SETTINGS_MODULE_KEYS.STAFFING]: StaffingSettings;
}

export interface UserSettings {
    version: number;
    modules: Partial<UserSettingsModuleMap>;
}

export interface ApiResponse<T> {
    data: T;
    message: string;
    success: boolean;
}
